// Using Vue for the panel calcualtor/repeater
const totalWidth = '0'
const total = new Vue({
  el: '#PANELcalculator',

  data: {
    items: [],
    openItems: [],
    toggle: ['two'],
  },

  computed: {
    totalSqft() {
      const sum = this.items.reduce((total, item) => {
        return total + (item.widthinches / 12 + Number(item.widthfeet)) * (Number(item.heightfeet) + item.heightinches / 12);
      }, 0);
      return sum.toFixed(2);
    },
    totalWidth(){
      return this.totalInches + this.totalFeet;
    },
    totalHeight(){
      return this.totalHeightFeet + this.totalHeightInches;
    },
    totalDimensions() {
      return `${this.totalWidth.toFixed(2)} * ${this.totalHeight.toFixed(2)}`;
    },
    allDimensions() {
      return this.items.map(item => {
        return {
          w: (item.widthinches / 12) + Number(item.widthfeet),
          h: (item.heightinches / 12) + Number(item.heightfeet)
        }
      })
    },
    totalInches(){
      return this.items.reduce((total, item) => {
        return total + item.widthinches / 12;
      }, 0);
    },
    totalFeet() {
      return this.items.reduce((total, item) => {
        return total + Number(item.widthfeet);
      }, 0);
    },
    totalHeightFeet() {
      return this.items.reduce((total, item) => {
        return total + Number(item.heightfeet);
      }, 0);
    },
    totalHeightInches(){
      return this.items.reduce((total, item) => {
        return total + item.heightinches / 12;
      }, 0);
    },

    //Total
    totalTotal(){
      return this.totalSqft;
    },
  },

  created() {
    this.addItem();
  },

  methods: {

    addItem() {
      this.items.push({
        widthinches: 0,
        widthfeet: 0,
        heightinches: 0,
        heightfeet: 0,
      });
    },
    deleteItem(i) {
      this.$delete(this.items, i);
    },
    toggleItem: function (key) {
    	var i = this.toggle.indexOf(key)
    	if (i < 0) {
      	this.toggle.push(key)
      } else {
      	this.toggle.splice(i, 1)
      }
    }
  },

});
  